// actions.js

import axios from 'axios';


export default {
    async fetchConditionsList(ctx){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/conditions`, config);
            ctx.commit('updateConditionsList', response.data) ;
        } catch (error) {
            return error;
        }
    },
    async fetchConditionsListByRule(ctx, {id}){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/conditions/by-rule/${id}`, config);
            ctx.commit('updateConditionsList', response.data) ;
        } catch (error) {
            return error;
        }
    },
    async fetchSaveCondition(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/conditions`,
                {
                    parameter_name: payload.parameter_name,
                    type: payload.type,
                    operator: payload.operator,
                    value: payload.value,
                    duration: payload.duration,
                    logic_opr: payload.logic_opr,
                    rule_id: payload.rule_id,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
        
    },
    async fetchMassSaveConditions(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/conditions/mass-update`,
                payload,
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }

    }
};
